module.exports = __webpack_public_path__ + "static/media/celebrate.0347ae9b.avif";